export default "__VITE_ASSET__iZ0WuaFN__"